<template>
	<component :is="url ? 'a' : 'div'" :href="url" class="wishlist-card">
		<div class="wishlist-card__image-wrap" v-if="imageUrl">
			<img :src="imageUrl" :alt="`wishlist item image for ${displayName}`" class="wishlist-card__image">
			<span class="wishlist-card__favorite-heart icon-whiteheart state-favorited"  @click="removeFromWishlist(id)"> <span class="path1"></span><span class="path2"></span> </span>
		</div>
		<div class="wishlist-card__content">
			<div class="wishlist-card__display-name" v-if="displayName">{{displayName}}</div>
			<div class="wishlist-card__finish-display-name" v-if="finishDisplayName">{{finishDisplayName}}</div>
		</div>
	</component>
</template>

<script setup lang="ts">
import {ref} from 'vue';
import {WishlistItemDelete} from "Api/apis";
import {useStore} from "vuex";
const store = useStore();
import { useToast } from 'vue-toastification';
const toast = useToast();
const componentName = 'WishlistCard';
const props = defineProps({
	displayName: String,
	finishDisplayName: String,
	id: Number,
	itemsLength: Number,
	imageUrl: String,
	url: String,
});
const isLastItem = ref<boolean>(false);
const emits = defineEmits(['itemDeleted']);
const removeFromWishlist = async(id) => {
	let response = await WishlistItemDelete(id, store?.state?.authToken);
	if(!response.isErrors) {
		toast.success(`Item has been removed from your wishlist successfully`, {
			timeout: 2000,
		});
		if(props.itemsLength === 1) {
			isLastItem.value = true;
		}
		emits('itemDeleted', isLastItem.value);
	} else {
		toast.error(`An error occurred, please try again`, {
			timeout: 2000,
		});
	}
};
</script>
